@import (reference) "../../references.less";

.root {
}

.blurFacesWrapper {
  .size(100%);
  position: absolute;
  top: 0;
}

.rect {
  position: absolute;
  //  z-index: -1;
}
